import { CallScreening } from "@/components/call-screening";
import { organisationCallscreeningQueryOptions, organisationQueryOptions } from "@/server/organisations";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { checkIfUserMayWrite, ContextUser } from "@/lib/utils";
import { CrudEntry } from "@/lib/mma/types.gen";
import { usePermissionRedirect } from "@/hooks/use-permission-redirect";

export const Route = createFileRoute("/_dashboard/organisations/$orgId/call-screening")({
  component: RouteComponent,
  beforeLoad: ({ location, params, context }) => {
    const search = (location as any).search || {};
    if (!search.tab) {
      throw redirect({
        to: "/organisations/$orgId/call-screening",
        params: { orgId: params.orgId },
        replace: true,
        search: { ...search, tab: "rules" },
      });
    }
  },
  loader: async ({ context }) => {
    return {
      user: context.user as ContextUser | null | undefined,
      crumb: "Call Screening",
      userProfileId: (context as { user?: { profile: string } }).user?.profile,
      accessControl: (context as { user?: { accessControl: Record<string, CrudEntry> } }).user?.accessControl,
    };
  },
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const { user, userProfileId, accessControl } = Route.useLoaderData();
  usePermissionRedirect({ user, permission: "CALL_SCREENING", redirectTo: "/organisations" });
  const mayWrite = checkIfUserMayWrite(userProfileId, accessControl, "CALL_SCREENING");
  const organisationQuery = useQuery(organisationQueryOptions(Number(orgId)));
  const organisationCallscreeningQuery = useQuery(organisationCallscreeningQueryOptions(Number(orgId)));
  const organisationCallscreeningData = organisationCallscreeningQuery.data as
    | {
        incoming?: { modify: string; black: string; white: string };
        outgoing?: { modify: string; black: string; white: string };
      }
    | undefined;

  useEffect(() => {
    if (!orgId) return;
    void organisationQuery.refetch();
    void organisationCallscreeningQuery.refetch();
  }, [orgId, organisationQuery.refetch, organisationCallscreeningQuery.refetch]);

  return (
    <CallScreening
      resourceId={Number(orgId)}
      callscreeningData={organisationCallscreeningData}
      resourceType="organisation"
      loading={organisationCallscreeningQuery.isLoading}
      mayWrite={mayWrite}
    />
  );
}
